import { Svg } from 'components/svg'
import type { IconType } from 'models.d'

export const IconPlay: IconType = ({ className = '', ...props }) => (
  <Svg
    {...props}
    className={className}
    viewBox="0 0 28 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.739258 30.6922V2.29987C0.739258 1.11178 1.98781 0.373033 2.98517 0.974695L26.5229 15.1709C27.5055 15.7649 27.5055 17.2348 26.5229 17.8288L2.98517 32.025C1.98781 32.6267 0.739258 31.8879 0.739258 30.6998V30.6922Z"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
    />
  </Svg>
)
